export default __webpack_public_path__ + "c4fed36b61045d4bebd13266058c86cf.svg";